import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

import { Card } from './style';

const SectionCard = ({
  title, subtitle, action, children,
}) => (
  <Card>
    {(title || subtitle || action) && (
      <Stack
        direction="row"
        alignItems={action ? 'center' : 'baseline'}
        justifyContent="space-between"
        spacing={1.5}
        mb={2}
      >
        {title && <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>}
        {action || (subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>)}
      </Stack>
    )}
    {children}
  </Card>
);

SectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
};

SectionCard.defaultProps = {
  title: null, subtitle: null, action: null, children: null,
};

export default SectionCard;
